/**
 *
 * AssemblyTypePicker
 *
 */

import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';
import { AssemblyTypePicker } from 'app/components/pickers/StaticOptionsPickers/AssemblyTypePicker';

export const AssetTypesFilter = (props: IFilterComponentProps): JSX.Element => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  //RENDER
  const { t } = useTranslation();
  return (
    <AssemblyTypePicker
      value={props.value as Entity<number> | undefined}
      onChange={handleOnChange}
      ariaLabel={props.label}
      id={props.id}
      size="small"
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
    />
  );
};

export default AssetTypesFilter;
